import { PremSettingFormValues } from "./prem-settings-form";

import { confirm, Grid, GridItem, Text } from "@bps/fluent-ui";
import {
  PremSettings,
  PremSettingsUpdate
} from "@libs/api/gateways/tg/tg-ops-gateway.dtos";
import { Fragment } from "react";

interface PremSettingsConfirmProps {
  values: PremSettingFormValues;
  premSettings: PremSettings[];
  onConfirm: (payload: PremSettingsUpdate[]) => void;
}

export const confirmPremSettings = async ({
  premSettings,
  values,
  onConfirm
}: PremSettingsConfirmProps) => {
  const dialogLabels = {
    title: "Update Premier Settings",
    content: "Please confirm the new setting values you are updating below:",
    buttons: {
      yes: "Update",
      no: "Cancel"
    }
  };

  const { updateValues } = values;
  const changedValues = updateValues.filter(value =>
    premSettings.find(
      setting =>
        setting.settingName === value.settingName &&
        setting.settingValue !== value.settingValue
    )
  );

  const isConfirm = await confirm({
    cancelButtonProps: {
      text: dialogLabels.buttons.no
    },
    confirmButtonProps: {
      text: dialogLabels.buttons.yes
    },
    dialogContentProps: {
      title: dialogLabels.title,
      subText: dialogLabels.content
    },
    minWidth: "550px",
    children: (
      <Grid
        templateColumns="auto 1fr"
        childrenTokens={{ columnGap: 24, rowGap: 4 }}
      >
        {changedValues.map(premSetting => {
          return (
            <Fragment key={premSetting.settingName}>
              <GridItem>
                <Text bold>{premSetting.settingName}</Text>
              </GridItem>
              <GridItem>{premSetting.settingValue}</GridItem>
            </Fragment>
          );
        })}
      </Grid>
    )
  });
  if (isConfirm) {
    onConfirm(changedValues);
  }
};
